// Tour step definitions for ShiftCover365 walkthroughs.
//
// IMPORTANT (Feb 2026): the tours below MUST only target
// `data-walkthrough` attributes that are actually rendered by the
// current 5-item Manager nav and 4-item Worker nav (see Phase 62 UX
// cleanup in ManagerLayout.jsx / WorkerLayout.jsx). Adding a step that
// points at an old sidebar item that no longer exists causes Joyride to
// spotlight nothing and show a full-screen grey overlay — this was the
// P0 "walkthrough greyed out" bug reported after the delete-and-register
// clean test.
//
// Each step targets a nav element via `data-walkthrough` and carries the
// route the app should navigate to BEFORE the tooltip is shown so the
// active nav item highlights consistently.

const baseStepProps = {
  disableBeacon: true,
  spotlightPadding: 6,
  placement: 'auto',
};

export const WORKER_TOUR_STEPS = [
  {
    target: '[data-walkthrough="wt-worker-available"]',
    title: 'Find Shifts',
    content: 'Browse open shifts near you and filter by postcode, city or branch.',
    route: '/worker',
    ...baseStepProps,
  },
  {
    target: '[data-walkthrough="wt-worker-my-shifts"]',
    title: 'My Shifts',
    content: 'Track shifts you applied for, assigned shifts and completed shifts.',
    route: '/worker/my-shifts',
    ...baseStepProps,
  },
  {
    target: '[data-walkthrough="wt-worker-messages"]',
    title: 'Messages',
    content: 'Chat with managers about the shifts you have applied for.',
    route: '/worker/chat',
    ...baseStepProps,
  },
  {
    target: '[data-walkthrough="wt-worker-profile"]',
    title: 'Profile',
    content: 'Keep your availability, experience and contact details up to date.',
    route: '/worker/profile',
    ...baseStepProps,
  },
];

export const MANAGER_TOUR_STEPS = [
  {
    target: '[data-walkthrough="wt-mgr-dashboard"]',
    title: 'Home',
    content: 'See your branch activity, active shifts, alerts and completed cover.',
    route: '/manager',
    ...baseStepProps,
  },
  {
    target: '[data-walkthrough="wt-mgr-find-cover"]',
    title: 'Find Cover',
    content: 'Tap here whenever you need someone to cover a shift — pick a date, time and location.',
    route: '/manager',
    ...baseStepProps,
  },
  {
    target: '[data-walkthrough="wt-mgr-shifts"]',
    title: 'Shifts',
    content: 'Track posted, assigned, active, completed and paid shifts.',
    route: '/manager/my-shifts',
    ...baseStepProps,
  },
  {
    target: '[data-walkthrough="wt-mgr-staff"]',
    title: 'Staff',
    content: 'Review applicants and manage the workers connected to your branch.',
    route: '/manager/staff',
    ...baseStepProps,
  },
  {
    target: '[data-walkthrough="wt-mgr-messages"]',
    title: 'Messages',
    content: 'Speak with applicants and the workers assigned to your shifts.',
    route: '/manager/chat',
    ...baseStepProps,
  },
  {
    target: '[data-walkthrough="wt-mgr-more"]',
    title: 'More',
    content: 'Alerts, billing, past shifts, branches, help and account settings all live here.',
    route: '/manager/more',
    ...baseStepProps,
  },
];
